// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FoldingContentTable_container__Amny3 {
    border: 1px solid #D9D9D9;
    border-radius: 6px;
    overflow: hidden;
}

.FoldingContentTable_container__Amny3 .even_row {
    background-color: #ffffff;
}

.FoldingContentTable_container__Amny3 .odd_row {
    background-color: #f5f5f5;
}
`, "",{"version":3,"sources":["webpack://./src/pages/detail/components/FoldingContentTable/index.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".container {\n    border: 1px solid #D9D9D9;\n    border-radius: 6px;\n    overflow: hidden;\n}\n\n.container :global(.even_row) {\n    background-color: #ffffff;\n}\n\n.container :global(.odd_row) {\n    background-color: #f5f5f5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FoldingContentTable_container__Amny3`
};
export default ___CSS_LOADER_EXPORT___;
